import styled from 'styled-components';
import { IThemeProvider } from '../../../../styles/theme';

export const MembersFooterCont = styled.div`
  display: flex;
  justify-content: space-between;
  ${({ theme }: IThemeProvider) => `
    margin: ${theme.layout.spacing.mikro} 0 26px ${theme.layout.spacing.nano};
  `};
`;
